// Generado desde design-system/theme/ThemeProvider.tsx — no editar; edita el .ts/.tsx y corre build-ds.
import { createContext, useContext, useEffect, useMemo, useState } from 'react';
const ThemeContext = createContext({ theme: 'light', setTheme: () => { } });
/**
 * Fija el tema (light | dark) en un contenedor con data-theme y lo comparte
 * por contexto (las gráficas lo necesitan: ECharts no lee CSS).
 * - `scope="root"` escribe data-theme en <html> (la app completa).
 * - `scope="local"` envuelve a sus hijos en un div con data-theme
 *   (permite previsualizar claro y oscuro lado a lado).
 * Si el proyecto ya controla data-theme en <html> con su propio contexto, usa
 * scope="local" con `theme` controlado, o solo `theme` sin escribir en <html>.
 */
export function DbThemeProvider({ theme: controlled, onThemeChange, defaultTheme = 'light', scope = 'local', className, children, }) {
    const [internal, setInternal] = useState(defaultTheme);
    const theme = controlled ?? internal;
    const setTheme = controlled != null && onThemeChange ? onThemeChange : setInternal;
    useEffect(() => {
        if (scope !== 'root')
            return undefined;
        const el = document.documentElement;
        const prev = el.getAttribute('data-theme');
        el.setAttribute('data-theme', theme);
        return () => {
            if (prev)
                el.setAttribute('data-theme', prev);
        };
    }, [theme, scope]);
    const value = useMemo(() => ({ theme, setTheme }), [theme, setTheme]);
    if (scope === 'root') {
        return <ThemeContext.Provider value={value}>{children}</ThemeContext.Provider>;
    }
    return (<ThemeContext.Provider value={value}>
      <div data-theme={theme} className={className}>
        {children}
      </div>
    </ThemeContext.Provider>);
}
export function useDbTheme() {
    return useContext(ThemeContext);
}
